import React from 'react';
import { Box, Card, Flex, FlexColumn, Icon, Text } from 'core/components';
import styled from 'styled-components';

const InteractiveCard = styled(Card)`
  cursor: ${({ disabled }) => (!disabled ? 'pointer' : 'default')};
  border-radius: 8px;
  border: 0 !important;
  ${({ theme, active, disabled }) =>
    !disabled
      ? `box-shadow: 0px 0px 0px 1px ${active ? theme.colors.primary : theme.colors.cardBorder} !important;`
      : ''}

  ${({ theme, active, disabled }) =>
    !disabled
      ? `&:hover {
    border: 0 !important;
    box-shadow: 0px 0px 0px 1px ${active ? theme.colors.primary : theme.colors.muted} !important;
  }`
      : ''}
`;
const CheckCard = ({ label, onClick, active, description, disabled }) => (
  <InteractiveCard p={0} active={active} onClick={!disabled ? onClick : null} disabled={disabled}>
    <FlexColumn p={2} flex={1} height="100%" justifyContent="center">
      <Flex justifyContent="space-between" alignItems="center" gap={2} minWidth={175}>
        <Box>
          <Text as="div" mb={0} disabled={disabled}>
            {label}
          </Text>
          {description && (
            <Text muted small>
              {description}
            </Text>
          )}
        </Box>

        {active && <Icon icon="tick-circle" color={disabled ? 'muted' : 'primary'} size={18} />}
        {!active && <Icon icon="circle" color="muted" size={18} />}
      </Flex>
    </FlexColumn>
  </InteractiveCard>
);

export default CheckCard;
